export class ApiError extends Error{constructor(message,response){super(message);this.response=void 0;this.response=response;}}